var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("comment-editor", {
    attrs: { id: _vm.id },
    model: {
      value: _vm.newCommentModel,
      callback: function($$v) {
        _vm.newCommentModel = $$v
      },
      expression: "newCommentModel"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }